<template>
  <a-layout style="height:100vh; background: #fff">
    <a-layout-header style="background: #787878">
      <Header />
    </a-layout-header>
    <div class="content">
      <div class="result-box">
        <img src="../../assets/a1_password_link_erroe.jpg" />
        <div class="result-tit">
          {{ $t('i18n_page_not_exist') }}
        </div>
      </div>
    </div>
  </a-layout>
</template>

<script>
import Header from '@GC/Header.vue'

export default {
  name: 'Error500',
  components: {
    Header
  }
}
</script>

<style scoped>
.content {
  max-width: 980px;
  margin: auto;
  position: relative;
  text-align: center;
  background: #fff;
  min-height: 500px;
  padding-top: 52px;
}
.result-box {
  display: inline-block;
  text-align: center;
}
.result-tit {
  font-size: 20px;
  margin-top: 7%;
  margin-right: 10%;
}
@media only screen and (max-width: 640px) {
  .content {
    padding: 30% 10% 0;
  }
  .result-box {
    width: 100%;
  }
  .result-box img {
    width: 100%;
  }
  .result-tit {
    font-size: calc(100% + 4px);
  }
}
</style>
